<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { IDish } from '@/stores/meals';

interface Props {
  dishes: IDish[];
}

withDefaults(defineProps<Props>(), {});
</script>

<template>
  <BasicBlock
    :icon="['far', 'soup']"
    :ariaDescription="`${$t('global.dishes')}`"
  >
    <div>
      <div
        v-for="(dish, index) in dishes"
        :key="index"
        class="w-[592px] bg-neutral-0 rounded-[12px] p-4 mb-8"
        :aria-label="dish.title"
      >
        <p class="mb-2">{{ dish.title }}</p>
        <img
          class="max-h-[310px] object-cover w-[560px]"
          v-optimized="{ size: 'medium', src: dish.picture.source }"
        />
      </div>
    </div>
  </BasicBlock>
</template>
